import axiosInstance from "../axiosInstance";

export const POSTAgregarUbiManual = async (idaudo, idubid, loggedUser) => {
  try {
    const { nombre } = loggedUser;

    if (!nombre || !idaudo || !idubid) {
      return {
        status: 400,
        message: "Faltan parámetros requeridos",
      };
    }

    const response = await axiosInstance.post(
      `${process.env.REACT_APP_WMS_BASE_URL}/auditoria/${idaudo}/agregar-ubi-manual/${idubid}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",

          usuario: nombre,
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default POSTAgregarUbiManual;
